import { Spinner } from './ui/spinner';

interface FullPageLoadingProps {
  message?: string;
}

export function FullPageLoading({ message }: FullPageLoadingProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <Spinner size={32} label={message ?? 'Carregando'} />
        {message && <p className="text-sm text-muted-foreground">{message}</p>}
      </div>
    </div>
  );
}
